
import './styles.css'
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import MyDiaryQuestion from './MyDiaryQuestion';
import { MeuDiarioQuestoes } from '../../../interfaces/entities/UnimedAcolhe/MeuDiarioQuestoes';
import { getHistoricoDiarioById } from '../../../services/SaudeBemEstar/MeuDiarioService';
import { CircularProgress } from '@mui/material';
import VoltarButton from '../../../components/Accessibility/VoltarButton';

function DiaryRegister() {
    const [questions, setQuestions] = useState<MeuDiarioQuestoes[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const { id } = useParams(); 

    const handleBack = () => {
        navigate("/saudeBemEstar/unimedAcolhe/meuDiario/inicio");
    }

    useEffect(() => {
        const getData = async () => {
            const result = await getHistoricoDiarioById(`${id}`);
            
            if(result !== null){
                setQuestions(result);
                setLoading(false);
            }
        }
        if(id !== undefined){
            setLoading(true);
            getData();
        }
    }, [id]);

    return (
        <div className="my-diary-holder">
            {loading && 
                <div className="loading-holder">
                    <CircularProgress />
                </div>
            }
            {!loading &&
                <>
                    {questions.map((question, index) => {
                        return(
                            <MyDiaryQuestion question={question} index={index} handleAnswer={() => {}} disabled={true}/>
                        )
                    })}
                    <VoltarButton onClick={handleBack} />
                </>
            }
        </div>
    )
}

export default DiaryRegister;